
/**
 * Created by liubaorui on 22/11/11.
 * @desc 非已类型区分为文件的所有公共方法
 */

import request from '@/router/axios';
import website from '@/config/website';
import { validatenull } from '@/util/validate'
import { disposeDic } from './field-config';
import {
    dayNowFn,
    dateFormat,
    getAllWeekBeforeNowFn,
    dayYestFn,
    getDateTimeByParam,
    getCurrentMonthEnd,
    getSettingDate
} from "@/util/date";
import { deepClone, getObjType } from "@/util/util";

// get方法公用
export function getRequset (url, params) {
    return request({
        url,
        method: 'get',
        params: {
            ...params
        }
    })
}

// Post 方法公用
export function postRequset (url, parameter) {
    return request({
        url,
        method: 'post',
        data: parameter
    })
}


// 异步可操作-询问结果提示框 业务文件this  传入自定义文字inject

export let inquiryResult = (th, inject = {}, showClose = true) => {
    const p = new Promise((resolve) => {
        th.$confirm(inject.confirmText || '此操作不可撤销，是否继续', '提示', {
            confirmButtonText: inject.confirmButtonText || '确定',
            cancelButtonText: inject.cancelButtonText || '取消',
            distinguishCancelAndClose: true,
            showClose,
            closeOnClickModal: false, // 是否可通过点击遮罩关闭
            closeOnPressEscape: false, // 是否可通过按下 ESC 键关闭
            type: 'warning'
        }).then(() => {
            resolve(true)
        }).catch((action) => {
            if (action == 'close') return
            resolve(false)
        })
    })
    return p
}

/*
* 参考公共混入文件 目前支持 统一 三列 或 四列
* 集成两种适配列数
*/

export const resizeGridSize = (searchNumber, spanNumber, option) => {
    if (spanNumber == 3) {
        switch (searchNumber.length % spanNumber) {
            case 1:
                option.searchMenuSpan = 16
                break;
            case 2:
                option.searchMenuSpan = 8
                break;
            case 0:
                option.searchMenuSpan = 24
                break;
        }

    } else if (spanNumber == 4) {
        switch (searchNumber.length % spanNumber) {
            case 1:
                option.searchMenuSpan = 18
                break;
            case 2:
                option.searchMenuSpan = 12
                break;
            case 3:
                option.searchMenuSpan = 6
                break;
            case 0:
                option.searchMenuSpan = 24
                break;
        }
    }
}

/*
* MutationObserver DOM 监听API 源自 Vue $nextTick设计原理
*/
export const mutationObserver = (callBack = () => { }, moDom, moConfig = { arrtibutes: true, attributeFilter: ['style'], attributeOldValue: true, }) => {
    if (!moDom) throw new Error('mutationObserver 函数未检测到有效值 MutationObserver “DOM”，需要监听的DOM是必要的。')
    const observer = new MutationObserver(callBack);
    observer.observe(moDom, moConfig)
}

/*
 * 函数劫持
 */
export const hijackFn = (obj, method, fun) => {
    let orig = obj[method]
    obj[method] = fun(orig);
}

// 统一处理 主子表代码生成 详情问题
export const disposeDetail = (Dom, className = 'avue--detail') => {
    process.nextTick(() => {
        const callBack = function () {
            let detailFrom = Dom && Dom.querySelector(`.${className}`);
            if (detailFrom) {
                let InmputDetail = detailFrom.getElementsByTagName('input');
                let switchDetail = detailFrom.getElementsByClassName('el-switch') || [];
                let TextareaDetail = detailFrom.getElementsByTagName('textarea');
                process.nextTick(() => {
                    Array.from(InmputDetail).forEach((item) => {
                        item.parentElement.onmouseover = function () {
                            item.title = item.value;
                            item.placeholder = ''
                        }
                        item.parentElement.addEventListener('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        })
                        item.disabled = true
                    })
                    Array.from(TextareaDetail).forEach((item) => {
                        item.parentElement.onmouseover = function () {
                            item.title = item.value;
                            item.placeholder = ''
                        }
                        item.parentElement.addEventListener('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        })
                        item.disabled = true
                    })

                    Array.from(switchDetail).forEach((item) => {
                        item.style.pointerEvents = 'none'
                    })
                })
            }
        };
        callBack()
        const moConfig = { arrtibutes: true, attributeFilter: ['style'], attributeOldValue: true, childList: true, }
        mutationObserver(callBack, Dom, moConfig)
    })
}
//============================ 图片相关处理及 关联函数 ============================

export function getBase64 (img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

export function dataURItoBlob (dataurl) {
    const arr = dataurl.split(','); const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]); let n = bstr.length; const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime, name: mime });
}

export function dataURLtoFile (dataurl, filename) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
export function dealImageCompression (path, newQuality, callback) {
    const img = new Image();
    img.src = path;
    img.onload = function () {
        // 默认按比例压缩
        let w = img.width;
        let h = img.height;
        let quality = 0.4;
        if (newQuality && newQuality <= 1 && newQuality > 0) {
            quality = newQuality;
        }
        w = w * quality;
        h = h * quality;
        // 生成canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(img, 0, 0, w, h);

        // 回调函数返回base64的值
        const base64 = canvas.toDataURL('image/jpeg', quality);
        // debugger;
        callback(base64);
        // return base64
    }
}
//=======================   END  ================================================


//=======================   列表详情千位符处理 及 关联函数 =========================

// 千位符处理函数
export function setSeparator (num) {
    if (!num) return num
    let number = num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
            return $1 + ",";
        });
    })
    return number;
}

/**
 * @description 对列表和详情的数据进行千位符处理
 * @param sourceData   数据源需要是Array或者Object （列表Array 详情Object）.
 * @param disposeList  需要千位处理的字段key 需要是Array,  如果是avue传入option 搭配 numFormat将自动处理
 * @param type         修改（edit）不处理
 * @return {Object/Array}  返回处理过的数据
 */
export function numSeparator (sourceData, disposeList, type = 'list') {
    if (type == 'edit') return sourceData //详情忽略
    if (!website.isSeparator) return sourceData //全局忽略
    //如果为option配置 自动处理为需要千位处理的字段
    let separatorData = []
    if (disposeList && disposeList.column) {
        disposeList.column.forEach(item => {
            if (item.numFormat) {
                separatorData.push(item.prop)
            }
        });
    } else {
        separatorData = disposeList
    }

    // 一. 当数据为数组时候
    if (Object.prototype.toString.call(sourceData) === '[object Array]') {
        //  处理数组脱敏
        separatorData.forEach((item) => {
            sourceData.forEach((sourceitem) => {
                sourceitem[item] = setSeparator(sourceitem[item])
            })
        })

        //二. 当数据为对象时
    } else if (Object.prototype.toString.call(sourceData) === '[object Object]') {
        //  处理对象脱敏
        separatorData.forEach((item) => {
            sourceData[item] = setSeparator(sourceData[item])
        })
    }
    return sourceData
}

//=======================   END  =================================================

/**
 * pdf转文件流
 * @param {String} dataurl pdf文件流
 * @param {String} filename 转型后的文件名称
 * @returns {File} 转换后的文件流对象
 */
export function dataPdfToFile (dataurl, filename) {
    // 将base64编码的pdf文件流转换为file对象
    let arr = dataurl.split(',');
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: 'application/pdf' });
}

/**
 * 下载Blob文件流
 * @param {Blob} content 文件流
 * @param {String} fileName 下载显示的名称（需要带格式）
 */
export function downloadBlob (content, fileName) {
    const blob = new Blob([content]) // 构造一个blob对象来处理数据

    // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性 IE10 以上支持 blob 但是依然不支持 download
    if ('download' in document.createElement('a')) { // 支持 a标签 download 的浏览器
        const link = document.createElement('a') // 创建a标签
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释放标签
    } else { // 其他浏览器
        navigator.msSaveBlob(blob, fileName)
    }
}


/**
 * 读取文件流转base64
 * @param {File} file  需要转换的文件
 * @returns {Promise<String>}  base64编码
 */
export function filetoBase64 (file) {

    return new Promise((resolve) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => { //文件读取成功完成时触发
            let dataURL = e.target.result; //获得文件读取成功后的DataURL,也就是base64编码
            // return dataURL
            resolve(dataURL)
        }
    })
}

/**
 * 根据约定类型返回  Boolean 值
 * @param {Object} itemObj  = {add:Boolean , view:Boolean edit:Boolean }
 * @param {String} type  = 'add'||'view'||'edit'
 * @returns {Boolean}  Boolean值
 */
export function showItem (itemObj, type) {
    if (validatenull(itemObj[type])) return itemObj.edit;
    return itemObj[type];
}
// 根据类型转换中文标题
export function transitionTitle (type) {
    const typeMap = {
        add: '新增',
        view: '详情',
        edit: '编辑'
    };
    return typeMap[type] || '未知';
}


/**
 * 身份证验证位数函数
 * @param {string} sfzh  - 18位身份证号
 * @returns {boolean}  -  true:通过 false:不通过
 */
export function checkSfzh (sfzh) {
    let index_array = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let sfzh_array = new Array();
    let total = 0;
    let last_number;
    let start = 0;
    let end = 1;
    for (let i = 0; i < sfzh.length - 1; i++) {
        let temp = sfzh.slice(start + i, end + i);
        sfzh_array.push(temp);
    }
    for (let i = 0; i < index_array.length; i++) {
        let temp = sfzh_array[i] * index_array[i];
        total = total + temp;
    }
    switch (total % 11) {
        case 0:
            last_number = 1;
            break;
        case 1:
            last_number = 0;
            break;
        case 2:
            last_number = 'X';
            break;
        case 3:
            last_number = 9;
            break;
        case 4:
            last_number = 8
            break;
        case 5:
            last_number = 7;
            break;
        case 6:
            last_number = 6;
            break;
        case 7:
            last_number = 5;
            break;
        case 8:
            last_number = 4;
            break;
        case 9:
            last_number = 3
            break;
        case 10:
            last_number = 2;
            break;
    }
    if (sfzh.slice(17, 18) == last_number) {
        return true;
    } else {
        return false;
    }
}

/**
 * form表单解析函数默认值
 * @param {*} item 字段对象
 * @param {*} defaultValueType 默认值类型  searchValue 搜索默认值类型  addValue 添加默认值类型
 * @returns
 */
export function formDefaultValueMothods (item, defaultValueType = 'addValue') {
    // 策略模式 - 关联默认值类型与处理函数
    const strategy = new Map([
        //假设当日2025-03-26
        ['getNowFormatTime', () => dateFormat(new Date())], // 当前时间 2025-03-26 11:41:46
        ['dayNowStart', () => dayNowFn('start')], // 当日开始时间 2025-03-26 00:00:00
        ['dayNowEnd', () => dayNowFn('end')],     // 当日结束时间 2025-03-26 23:59:59
        ['yestStart', () => dayYestFn('start')],      // 昨日开始时间 2025-03-25 00:00:00
        ['weekStart', () => getAllWeekBeforeNowFn('weekStart')], // 7日前时间 2025-03-20 00:00:00
        ['weekRange', () => getAllWeekBeforeNowFn()], // 近7天时间区间  2025-03-20 00:00:00,2025-03-26 23:59:59
        ['endMonth', () => getCurrentMonthEnd() + ' 23:59:59'], // 当前月月底  2025-03-31 23:59:59
        ['afterNowThirtyDayEnd', () => getDateTimeByParam('30', 'end')],  // 当前时间30天后结束时间  2025-04-25 23:59:59
        ['thirtyDaysBeforeTime', () => getDateTimeByParam('-30', 'end')], // 当前时间30天前结束时间  2025-02-24 23:59:59
    ]);
    // 计算默认值
    const getCalculatedValue = (type, key) => {
        return strategy.has(key) ? strategy.get(key)() : '';
    };

    let defaultValue = defaultValueType === 'addValue' ? item.initialValue : item.searchValue;
    let calculatedValue = getCalculatedValue(defaultValueType, defaultValue);

    return calculatedValue !== '' ? calculatedValue : defaultValue;
}

// --------------处理主子表动态字段---------------------

/**
 * @description
 *  根据弹窗格式处理字段显隐，以及可读
 * @param columns 字段列表
 * @param dialogType 弹窗类型
 * @param tableType 区分主表 子表
 * @param customPropObj 自定义字段追加，设置可编辑等
 * *******@param maineditablePropObj 主表要可编辑的字段
 * *******@param subeditablePropObj 子表可编辑的字段
 * *******@param mainAddedPropList 主表要追加的字段
 * *******@param subAddedPropList 主表要追加的字段
 *
 * @returns {Array} 一个包含了所有字段的数组
 */
export const getOptionColumn = (columns, dialogType, customPropObj = {}, tableType) => {
    const {
        maineditablePropObj = {},
        mainAddedPropList = [],
        subeditablePropObj = {},
        subAddedPropList = []
    } = customPropObj

    let list = [];
    let addList = tableType === 'main' ? mainAddedPropList : subAddedPropList
    let editablePropObj = tableType === 'main' ? maineditablePropObj : subeditablePropObj

    columns.forEach(element => {
        let disabled = false
        // disabled控制：处理追加,延长有效期等另类操作是否禁用
        if (!validatenull(maineditablePropObj) || !validatenull(subeditablePropObj) || mainAddedPropList.length > 0 || subAddedPropList.length > 0) {
            disabled = showItem({
                add: element.addDisabled,
                view: true,
                edit: !editablePropObj[element.prop] ? true : false // 除传入的字段都为禁用
            }, dialogType)
        } else {
            // 处理添加/编辑字段disabled
            disabled = showItem({
                add: element.addDisabled,
                edit: element.editDisabled,
                view: true
            }, dialogType)
        }

        // display控制：根据操作类型控制显隐
        let display = showItem({
            add: element.addDisplay,
            view: element.viewDisplay,
            edit: element.editDisplay
        }, dialogType)

        /**
         * 处理主子表弹窗avue-form 编辑赋默认值问题
         */
        if (dialogType != 'add') delete element.value

        list.push({
            ...element,
            display,
            disabled
        })
    })
    return [...list, ...addList]
}

/**
 * 根据数据库字段类型，获取对应的前端组件类型
 * @param {string} type - 数据库字段类型
 * @returns {string} - 前端组件类型
 */
const getFieldType = (type) => {
    let fieldType = ""
    switch (type) {
        case 'input': // 文本
            fieldType = 'input'
            break;
        case 'remark': // 文本域
            fieldType = 'textarea'
            break;
        case 'tree': // 单选树形下拉框
        case 'multiple_tree': // 多选树形下拉框
            fieldType = 'tree'
            break;
        case 'search_datetime': // 查询时间框 例：2023-03-24 11:16-2023-03-24 11:18
        case 'day_date': // 日期框      例：2023-03-24
        case 'time_date': // // 时间框  例：2023-03-24 11:16
            fieldType = 'datetime'
            break;
        default: // 默认：适用字典下拉框，下拉多选，拼音码
            fieldType = 'select'
            break;
    }
    return fieldType
}

/**
 * @description 处理单个字段配置
 *
 * @param {Object} that - 上下文对象
 * @param {Object} field - 字段配置对象
 * @returns {Object} - avue字段配置对象
 */
const processFieldConfig = (that, field) => {
    const processed = disposeDic(field)

    // 基础字段配置
    const getBaseConfig = {
        label: processed.columnName, // 列名称
        prop: processed.columnAlias, // 列字段
        type: getFieldType(processed.columnModel), // 字段数据类型
        dataType: processed.dictKey || processed.columnModel === 'search_datetime' ? 'string' : null,
        value: processed.initialValue || '', // 默认值
        placeholder: processed.placeholde || processed.formPlaceholder, // 控件提示语
        align: processed.listAlign || 'left',
        headerAlign: 'left',
        width: processed.columnWidth || 'auto', // 列宽度
        minWidth: 'auto', // 列最小宽度
        maxlength: processed.columnLength,
    }

    // 搜索相关配置
    const getSearchConfig = {
        search: Boolean(processed.queryShowFlag),   // 是否支持搜索
        remote: processed.remote || false,
        searchValue: processed.searchInitialValue,
        searchDisabled: processed.searchDisabled == '1' ? true : false,
        searchRange: processed.columnModel == 'search_datetime' ? true : null,
        // 组件类型：tree/multiple_tree为多选
        searchMultiple: ['tree', 'multiple_tree'].includes(processed.columnModel) ? true : false,
        cascader: processed.cascader ? [processed.cascader] : null,
        defaultExpandAll: true,
        checkStrictly: true,
    }

    // 组件格式文本域
    const isTextarea = processed.columnModel === 'remark'
    // 日期格式
    const dateFormat = processed.columnModel === 'day_date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'

    // 表单控件配置
    const getFormConfig = {
        span: processed.spanNumber || (isTextarea ? 24 : 8),  // 表单栅列
        lableWidth: processed.lableWidth || 130, // 表单标签宽度
        maxRows: 4, // 最大行（当type为textarea）
        minRows: 2, // 最小行（当type为textarea）
        format: dateFormat, // 显示在输入框中的格式
        valueFormat: dateFormat, // 绑定值的格式
        defaultTime: processed.defaultTime || null,
        clearable: true, // 是否显示清除按钮
        rules: processed.rules, // 表单规则,参考ele表单规则配置Object
        dicData: processed.dicData,  // 传入本次需要的静态字典（在column中dicData写对象key值即可加载）
        dicUrl: processed.dicUrl,  // 字典的网络请求接口（例如配置/xxx/xx/{{key}},这样的格式，在column中dicData自动匹配prop字段名）
        props: processed.props,
    }

    // 显示控制配置
    const getDisplayConfig = {
        hide: Boolean(!processed.listShowFlag), // 隐藏列 表格起作用
        showColumn: Boolean(!processed.showColumn),  // 参与自定义列显隐
        readonly: processed.readonlyModel == '4' ? true : null,
        disabled: processed.readonlyModel == '3' ? true : null,
        addDisabled: [1, 3].includes(processed.readonlyModel),  // 表单添加时是否禁用
        addDisplay: Boolean(processed.addShowFlag),
        editDisabled: [2, 3].includes(processed.readonlyModel) ? true : false, // 表单编辑时是否禁用
        editDisplay: Boolean(processed.updateShowFlag),
        viewDisplay: Boolean(processed.detailShowFlag),
        slot: false,        // 列自定义 支持自定义列
        formslot: false,    // 表单自定义
        fixed: false,        // 冻结列
        overHidden: true,  // 超出隐藏
        sortable: false,  // 排序
        formatter: '',

    }

    // 自定义字段
    const getCustomConfig = {
        requestUrl: processed.requestUrl,
        isRequired: Boolean(processed.isRequired),
        columnModel: processed.columnModel,
        numFormat: Boolean(processed.isThousandCut),
        dictKey: processed.dictKey,
        columnType: processed.columnType,
        initialValue: processed.initialValue || '', // 默认值
        advancedSearch: processed.advancedSearch || false,  // 高级查询控制
        remark: processed.remark,
    }


    // 事件处理
    const eventHandlers = {
        change: ({ value, column }) => {
            that.onCrudChange && that.onCrudChange({ column, value, prop: processed.columnAlias })
        },
        click: ({ value, column }) => {
            that.onCrudClick && that.onCrudClick({ column, value, prop: processed.columnAlias })
        },
        blur: ({ value, column }) => {
            that.onCrudBlur && that.onCrudBlur({ column, value, prop: processed.columnAlias })
        },
        focus: ({ value, column }) => {
            that.onCrudFocus && that.onCrudFocus({ column, value, prop: processed.columnAlias })
        },
    }

    return {
        ...getBaseConfig,
        ...getSearchConfig,
        ...getFormConfig,
        ...getDisplayConfig,
        ...getCustomConfig,
        ...eventHandlers,
    }
}

/**
 * @description 处理接口返回的字段配置数据,转换为Avue可用的配置格式
 *
 * @param {Array} sourceData - 接口返回的原始字段配置数据
 * @param {Function} [callBack] - 可选的回调函数,用于处理异步场景
 *                               例如:字典数据需要异步加载的情况
 * @returns {Array|*} - 返回处理后的Avue字段配置数组,如果传入回调则返回回调的执行结果
 */
export function filtrConfig (sourceData, callBack) {
    const processedConfig = sourceData.map((item) => processFieldConfig(this, item))
    return typeof callBack == 'function' ? callBack(processedConfig) : processedConfig
}


// --------------处理主子表动态字段---------------------

/**
 * @description 手动设置查询间隔限制，用loading间隔查询时间
 * @param {Element} el - DOM元素
 * @param {Number} time - 间隔时间 ms
 */
export function setLoading (el, time = 1200) {
    if (el) {
        const menuBtn = el && el.querySelector('.avue-form__menu')
        if (menuBtn) {
            const menuBtnItem = Array.from(menuBtn.querySelectorAll('.el-button'))
            menuBtnItem.forEach((item) => {
                // 添加loading状态
                item.classList.add('button-disable')
                const i_tag = item.querySelector('i')
                if (i_tag) {
                    // 保存原始icon
                    const icon = i_tag.classList[0]
                    // loading动画
                    i_tag.classList = []
                    i_tag.classList.add('el-icon-loading')
                    // 等待完毕恢复原始状态
                    setTimeout(() => {
                        i_tag.classList = [icon]
                        item.classList.remove('button-disable')
                    }, time)
                }
            })
        }
    }
}
/**
 * @description 对象转数组
 */
export function objectToArray (obj) {
    const resultArray = [];
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            resultArray.push(obj[key]);
        }
    }
    return resultArray;
}
/**
 * @description 排序并去重
 */
export function uniqueAndSortArray (arr) {
    // 使用 Set 去重
    const uniqueSet = new Set(arr);
    // 将 Set 转换回数组并排序
    const uniqueSortedArray = Array.from(uniqueSet).sort((a, b) => a - b); // 对于数字数组
    return uniqueSortedArray;
}

/**
 * crud column 时间查询配置
 */
const searchTimeFormatMap = {
    datetime: "yyyy-MM-dd HH:mm:ss",
    datetimerange: "yyyy-MM-dd HH:mm:ss",
    date: "yyyy-MM-dd",
    daterange: "yyyy-MM-dd",
    month: "yyyy-MM",
    monthrange: "yyyy-MM",
};

const searchTimeMomentFormatMap = {
    datetime: "YYYY-MM-DD HH:mm:ss",
    datetimerange: "YYYY-MM-DD HH:mm:ss",
    date: "YYYY-MM-DD",
    daterange: "YYYY-MM-DD",
    month: "YYYY-MM",
    monthrange: "YYYY-MM",
};

const getSearchTimeFormat = (type = "datetime") => searchTimeFormatMap[type] || searchTimeFormatMap.datetime;

const getSearchTimeMomentFormat = (type = "datetime") => searchTimeMomentFormatMap[type] || searchTimeMomentFormatMap.datetime;

export const getDefaultSearchTimeRange = (type = "datetime") => {
    const format = getSearchTimeMomentFormat(type);
    return [
        getSettingDate("daySLast7", { format }),
        getSettingDate("dayE", { format }),
    ];
};

const getShortcutRange = (startType, endType, type) => {
    const format = getSearchTimeMomentFormat(type);
    return [
        getSettingDate(startType, { format }),
        getSettingDate(endType, { format }),
    ];
};

const getYesterdayRange = (type) => {
    const format = getSearchTimeMomentFormat(type);
    const date = getSettingDate("customTime", { format: "YYYY-MM-DD", num: -1 });
    if (format.indexOf("HH") > -1) {
        return [`${date} 00:00:00`, `${date} 23:59:59`];
    }
    if (format === "YYYY-MM") {
        const month = getSettingDate("customTime", { format, num: -1 });
        return [month, month];
    }
    return [date, date];
};

export const getSearchTimePickerOptions = (type = "datetime") => ({
    shortcuts: [
        {
            text: "今日",
            onClick (picker) {
                picker.$emit("pick", getShortcutRange("dayS", "dayE", type));
            },
        },
        {
            text: "昨日",
            onClick (picker) {
                picker.$emit("pick", getYesterdayRange(type));
            },
        },
        {
            text: "最近一周",
            onClick (picker) {
                picker.$emit("pick", getShortcutRange("daySLast7", "dayE", type));
            },
        },
        {
            text: "最近一个月",
            onClick (picker) {
                picker.$emit("pick", getShortcutRange("daySLast30", "dayE", type));
            },
        },
        {
            text: "最近三个月",
            onClick (picker) {
                picker.$emit("pick", getShortcutRange("daySLast90", "dayE", type));
            },
        },
    ],
    disabledDate (time) {
        return time.getTime() > new Date(getSettingDate("dayE")).getTime();
    },
});

const pickerOptions = getSearchTimePickerOptions();

export const searchTimeConfig = {
    label: "查询时间",
    prop: "searchDate",
    type: "datetime",
    search: true,
    searchSpan: 9,
    hide: true,
    showColumn: false,
    format: getSearchTimeFormat(),
    valueFormat: getSearchTimeFormat(),
    viewDisplay: false,
    addDisplay: false,
    editDisplay: false,
    searchValue: getDefaultSearchTimeRange(),
    dateDefault: true,
    overHidden: true,
    searchRange: true,
    defaultTime: ["00:00:00", "23:59:59"],
    clearable: false,
    pickerOptions,
};

/**
 * crud column 时间查询配置
 * 现状代码太多 不需要默认值改用获取函数
 */
export const getSearchTimeConfig = (defaultVal = [], config = {}) => {
    const currentConfig = { ...config };
    let currentDefaultVal = defaultVal;
    if (typeof defaultVal === "string") {
        currentConfig.label = currentConfig.label || defaultVal;
        currentDefaultVal = [];
    }
    const type = currentConfig.type || "datetime";
    const format = currentConfig.format || getSearchTimeFormat(type);
    return {
        label: currentConfig.label || "查询时间",
        prop: currentConfig.prop || "searchDate",
        type,
        search: true,
        searchSpan: currentConfig.searchSpan || 9,
        hide: true,
        showColumn: false,
        format,
        valueFormat: currentConfig.valueFormat || format,
        viewDisplay: false,
        addDisplay: false,
        editDisplay: false,
        searchValue: Array.isArray(currentDefaultVal) && currentDefaultVal.length
            ? currentDefaultVal
            : getDefaultSearchTimeRange(type),
        dateDefault: true,
        overHidden: true,
        searchRange: true,
        defaultTime: currentConfig.defaultTime || ["00:00:00", "23:59:59"],
        clearable: false,
        pickerOptions: currentConfig.pickerOptions || getSearchTimePickerOptions(type),
    }
}

export const formatterTime = (str) => {
    return str === '1970-01-01 00:00:00' ? '' : str
}

export const initDataTime = (data, column) => {
    const times = column.filter(item => item.type === 'datetime').map(item => item.prop)
    let result = deepClone(data)
    const type = getObjType(result)
    if (type === 'array') {
        result.forEach(item => {
            times.forEach(t_k => {
                if (item[t_k]) {
                    item[t_k] = formatterTime(item[t_k])
                }
            })
        })
    } else if (type === 'object') {
        times.forEach(t_k => {
            if (result[t_k]) {
                result[t_k] = formatterTime(result[t_k])
            }
        })
    } else if (type === 'string') {
        result = formatterTime(result)
    } else {
        console.error('data类型不符合')
    }
    return result;
}

export const rulesInput = (msgType = 1) => [
    {
        required: true,
        message: msgType === 1 ? "请输入" : '请输入',
        trigger: ["blur", 'change'],
    },
]

/**
 * 从对象数组中提取指定键的title值和value值，分别形成两个数组
 * @param {Array} data - 源数据数组
 * @param {string} titleKey - 需要提取的title对应的键名
 * @param {string} valueKey - 需要提取的value对应的键名
 * @returns {Array} 包含两个数组的数组，格式：[title数组, value数组]
 */
 export function extractTitleAndValueArrays (data, titleKey, valueKey) {
    // 校验输入数据合法性
    if (!Array.isArray(data)) {
        console.error('第一个参数必须是数组');
        return [[], []];
    }
    const titles = [];
    const values = [];
    data.forEach(item => {
        titles.push(item[titleKey]);
        values.push(item[valueKey]);
    });

     return { titles, values };
}
